module.exports = __webpack_public_path__ + "img/bind.ced53a25.png";